<template>
  <div>
    <router-view></router-view>
    <MyFooter/>
  </div>
</template>

<script>
import MyFooter from "@/components/MyFooter.vue";
import GroupHeader from "@/components/group/GroupHeader.vue";

export default {
  name: 'App',
  components: {
    GroupHeader,
    MyFooter
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;

}

/*滚动条整体样式*/
body::-webkit-scrollbar {
  width: 10px;
  height: 1px;
}

/*滚动条里面小方块*/
body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #BC9B5D;
  background-image: -webkit-linear-gradient(
          45deg,
          rgba(255, 255, 255, .2) 25%,
          transparent 25%,
          transparent 50%,
          rgba(255, 255, 255, .2) 50%,
          rgba(255, 255, 255, .2) 75%,
          transparent 75%,
          transparent
  );
}

/*滚动条里面轨道*/
body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  /*border-radius: 10px;*/
  background: #EDEDED;
}


@media (min-width: 640px) {
  html {
    font-size: 12px;
  }
}

@media (min-width: 768px) {
  html {
    font-size: 13px;
  }
}

@media (min-width: 1024px) {
  html {
    font-size: 14px;
  }
}

@media (min-width: 1280px) {
  html {
    font-size: 15px;
  }
}

@media (min-width: 1536px) {
  html {
    font-size: 16px;
  }
}
</style>
